<div class="dsp-toast-list-wrapper">
    <div *ngFor="let message of ToastMessages;" @inOutAnimation class="dsp-toast-box-wrapper">
        <dsp-toast-box [ToastMessage]="message" (DismissToastEvent)="DismissMessage($event)"></dsp-toast-box>
    </div>
</div>